if (!customElements.get('component-cart-header')) {
  customElements.define('component-cart-header', class CartHeader extends HTMLElement {
    constructor() {
      super();

      this.settings = {
        fsEnabled: this.dataset.fsEnabled === 'true',
        fsTextEnabled: this.dataset.fsTextEnabled === 'true',
        fsThreshold: +this.dataset.fsThreshold,
        fsTextTmpl: this.dataset.fsTextTmpl,
        fsLoyaltyFirstTierTextTmpl: this.dataset.fsLoyaltyFirstTierTextTmpl,
        fsLoyaltySecondTierTextTmpl: this.dataset.fsLoyaltySecondTierTextTmpl,
        fsSuccessTextTmpl: this.dataset.fsSuccessTextTmpl,
        sgdEnabled: this.dataset.sgdEnabled === 'true',
        sgdUiType: this.dataset.sgdUiType,
        sgdShowFsOnTiers: this.dataset.sgdShowFsOnTiers === 'true',
        sgdDynamicTextEnabled: this.dataset.sgdDynamicTextEnabled === 'true',
        sgdDynamicTextTemplate: this.dataset.sgdDynamicTextTemplate,
        sgdDynamicTextTemplateLastThreshold: this.dataset.sgdDynamicTextTemplateLastThreshold,
        sgdDynamicLargeTextEnabled: this.dataset.sgdDynamicLargeTextEnabled === 'true',
        sgdDynamicLargeTextTemplate: this.dataset.sgdDynamicLargeTextTemplate,
        sgdDynamicLargeTextTemplateLastThreshold: this.dataset.sgdDynamicLargeTextTemplateLastThreshold,
        sgdFirstThreshold: +this.dataset.sgdFirstThreshold || 0,
        sgdSecondThreshold: +this.dataset.sgdSecondThreshold || 0,
        sgdThirdThreshold: +this.dataset.sgdThirdThreshold || 0,
        sgdFourthThreshold: +this.dataset.sgdFourthThreshold || 0,
        sgdDiscountType: +this.dataset.sgdDiscountType || 'fixed',
        sgdFirstDiscount: +this.dataset.sgdFirstDiscount || 0,
        sgdSecondDiscount: +this.dataset.sgdSecondDiscount || 0,
        sgdThirdDiscount: +this.dataset.sgdThirdDiscount || 0,
        sgdFourthDiscount: +this.dataset.sgdFourthDiscount || 0,
        sgdExcludeThresholdTagName: this.dataset.sgdExcludeThresholdTagName,
        sgdExcludeDiscountTagName: this.dataset.sgdExcludeDiscountTagName,
        sgdExcludeDiscountKitProducts: this.dataset.sgdExcludeDiscountKitProducts === 'true',
        bdEnabled: this.dataset.bdEnabled === 'true',
        bdDiscountType: this.dataset.bdDiscountType || 'fixed',
        bdFirstItem: +this.dataset.bdFirstItem || 0,
        bdSecondItem: +this.dataset.bdSecondItem || 0,
        bdThirdItem: +this.dataset.bdThirdItem || 0,
        bdFourthItem: +this.dataset.bdFourthItem || 0,
        bdFifthItem: +this.dataset.bdFifthItem || 0,
        bdTag: this.dataset.bdTag,
        bdProductType: this.dataset.bdProductType,
        bdHeaderBannerEmptyTemplate: this.dataset.bdHeaderBannerEmptyTemplate || '',
        bdHeaderBannerTemplate: this.dataset.bdHeaderBannerTemplate || '',
        bdHeaderBannerMaxTemplate: this.dataset.bdHeaderBannerMaxTemplate || '',
        gwpEnabled: this.dataset.gwpEnabled === 'true',
        gwpMultipleGiftEnabled: this.dataset.gwpMultipleGiftEnabled === 'true',
        gwpShowFsOnTiers: this.dataset.gwpShowFsOnTiers === 'true',
        gwpFirstThreshold: +this.dataset.gwpFirstThreshold || 0,
        gwpFirstBoxTitle: this.dataset.gwpFirstBoxTitle,
        gwpSecondThreshold: +this.dataset.gwpSecondThreshold || 0,
        gwpSecondBoxTitle: this.dataset.gwpSecondBoxTitle,
        gwpThirdThreshold: +this.dataset.gwpThirdThreshold || 0,
        gwpThirdBoxTitle: this.dataset.gwpThirdBoxTitle,
        gwpThresholdUseTotal: this.dataset.gwpThresholdUseTotal === 'true',
        gwpIncludeTag: this.dataset.gwpIncludeTag,
        gwpExcludeTag: this.dataset.gwpExcludeTag,
        gwpExcludeProductTypeList: this.dataset.gwpExcludeProductTypeList,
        gwpBannerBeforeThreshold: this.dataset.gwpBannerBeforeThreshold,
        gwpBannerAfterThreshold: this.dataset.gwpBannerAfterThreshold,
        gwpBannerGiftAdded: this.dataset.gwpBannerGiftAdded
      }

      if (this.settings.bdProductType == 'all') {
        this.settings.bdProductType = 'item';
      }

      this.buttonClose = this.querySelector('.js-cart-header-close-button');
      this.buttonBag = this.querySelector('.js-cart-header-bag-button');

      if (this.settings.gwpEnabled) {
        this.gwpBanner = this.querySelector('.js-gwp-banner');
        this.gwpFsCircle = this.querySelector('.js-gwp-fs-circle');
        this.gwpFsLine = this.querySelector('.js-gwp-fs-line');
        this.gwpFirstCircle = this.querySelector('.js-gwp-first-circle');
        this.gwpFirstLine = this.querySelector('.js-gwp-first-line');
        this.gwpSecondCircle = this.querySelector('.js-gwp-second-circle');
        this.gwpSecondLine = this.querySelector('.js-gwp-second-line');
        this.gwpThirdCircle = this.querySelector('.js-gwp-third-circle');
      }

      if (this.settings.sgdEnabled) { 
        this.sgdDynamicText = this.querySelector('.js-sgd-dynamic-text');
        this.sgdDynamicLargeText = this.querySelector('.js-sgd-dynamic-large-text');
        this.sgdFirstProgress = this.querySelector('.js-first-progress');
        this.sgdSecondProgress = this.querySelector('.js-second-progress');
        this.sgdThirdProgress = this.querySelector('.js-third-progress');
        this.sgdFourthProgress = this.querySelector('.js-fourth-progress');
        this.sgdFirstLabel = this.querySelector('.js-first-label-bottom');
        this.sgdSecondLabel = this.querySelector('.js-second-label-bottom');
        this.sgdThirdLabel = this.querySelector('.js-third-label-bottom');
        this.sgdFourthLabel = this.querySelector('.js-fourth-label-bottom');
      }

      if (this.settings.fsEnabled && this.settings.fsTextEnabled) {
        this.fsBanner = this.querySelector('.js-fs-banner');
      }

      if (this.settings.fsEnabled) {
        this.sgdFreeShippingProgress = this.querySelector('.js-fs-progress');
        this.sgdFreeShippingLabel = this.querySelector('.js-fs-label-bottom');
        // Free shipping progress bar of its own (not on the SGD tiers)
        this.fsProgressBar = this.querySelector('.js-fs-progress-bar');
        this.fsProgressBarLabel = this.querySelector('.js-fs-progress-bar-label');
      }

      if (this.settings.bdEnabled && !this.settings.sgdEnabled) {
        this.bdBanner = this.querySelector('.js-bd-banner');
        this.progressFirstItem = this.querySelector('.js-progress-1-items');
        this.progressSecondItem = this.querySelector('.js-progress-2-items');
        this.progressThirdItem = this.querySelector('.js-progress-3-items');
        this.progressFourthItem = this.querySelector('.js-progress-4-items');
        this.progressFifthItem = this.querySelector('.js-progress-5-items');
        this.labelFirstItem = this.querySelector('.js-label-1-items');
        this.labelSecondItem = this.querySelector('.js-label-2-items');
        this.labelThirdItem = this.querySelector('.js-label-3-items');
        this.labelFourthItem = this.querySelector('.js-label-4-items');
        this.labelFifthItem = this.querySelector('.js-label-5-items');
      }

      this.setEventListeners();
    }

    setEventListeners() {
      this.buttonClose?.addEventListener('click', () => {
        window.broadcastChannel.dispatchEvent('close-cart-drawer');
      });

      this.buttonBag?.addEventListener('click', () => {
        window.broadcastChannel.dispatchEvent('close-cart-drawer');
      });

      window.addEventListener('update-cart-header-banners', () => {
        let cart = window.cartManager.getLocalCart();

        if (this.fsProgressBar) {
          this.fsProgressBar.value = cart.total;
          this.fsProgressBarLabel?.classList.toggle('bold', cart.total >= this.settings.fsThreshold);
        }

        if (this.settings.fsEnabled && this.settings.fsTextEnabled && this.settings.fsTextTmpl && this.settings.fsSuccessTextTmpl) {
          const amount = Math.round(this.settings.fsThreshold - cart.total);
          if (amount <= 0) {
            this.fsBanner.innerHTML = this.settings.fsSuccessTextTmpl.replace('#x', toMoney(amount)).replace('#y', toMoney(this.settings.fsThreshold)).replace('#z', window.theme?.loyalty?.customer?.tier_name || '');
          } else {
            if (window.theme?.loyalty?.customer?.tier_number === 1) {
              this.fsBanner.innerHTML = this.settings.fsLoyaltyFirstTierTextTmpl.replace('#x', toMoney(amount)).replace('#y', toMoney(this.settings.fsThreshold)).replace('#z', window.theme?.loyalty?.customer?.tier_name || '');  
            } else if (window.theme?.loyalty?.customer?.tier_number === 2) {
              this.fsBanner.innerHTML = this.settings.fsLoyaltySecondTierTextTmpl.replace('#x', toMoney(amount)).replace('#y', toMoney(this.settings.fsThreshold)).replace('#z', window.theme?.loyalty?.customer?.tier_name || '');
            } else {
              this.fsBanner.innerHTML = this.settings.fsTextTmpl.replace('#x', toMoney(amount)).replace('#y', toMoney(this.settings.fsThreshold)).replace('#z', window.theme?.loyalty?.customer?.tier_name || '');
            }
          }
        }

        if (this.settings.sgdFirstThreshold && this.settings.sgdFirstDiscount) {
          let cartTotalPrice = cart.items.reduce((cartTotal, item, index) => {
            if (this.settings.sgdExcludeThresholdTagName && item.properties._tags?.includes(this.settings.sgdExcludeThresholdTagName)) {
              return cartTotal;
            } else if (this.settings.sgdExcludeDiscountTagName && item.properties._tags?.includes(this.settings.sgdExcludeDiscountTagName)) {
              return cartTotal;
            } else if (this.settings.sgdExcludeDiscountKitProducts && item.properties._hasDiscountKitApplied) {
              return cartTotal;
            } else if (item.properties._isGWP) {
              return cartTotal;
            } else if (item.properties._abId) {
              return cartTotal;
            } else {
              return cartTotal + item.original_line_price;
            }
          }, 0);

          const diffFs = this.settings.fsThreshold - cart.total;
          const diff1 = this.settings.sgdFirstThreshold - cartTotalPrice;
          const diff2 = this.settings.sgdSecondThreshold - cartTotalPrice;
          const diff3 = this.settings.sgdThirdThreshold - cartTotalPrice;
          const diff4 = this.settings.sgdFourthThreshold - cartTotalPrice;

          if (this.settings.sgdEnabled) {
            if (this.settings.sgdDynamicTextEnabled || this.settings.sgdUiType === 'default' || this.settings.sgdUiType === 'simple') {
              if (this.settings.sgdFourthThreshold && diff4 <= 0) {
                this.sgdDynamicText.innerHTML = this.settings.sgdDynamicTextTemplateLastThreshold.replace('#x', toMoney(diff4)).replace('#y', toMoney(this.settings.sgdFourthThreshold)).replace('#z', this.settings.sgdDiscountType ? `${this.settings.sgdFourthDiscount}%` : `$${this.settings.sgdFourthDiscount}`);
                if (this.settings.sgdDynamicLargeTextEnabled) this.sgdDynamicLargeText.innerHTML = this.settings.sgdDynamicLargeTextTemplateLastThreshold.replace('#x', toMoney(diff4)).replace('#y', toMoney(this.settings.sgdFourthThreshold)).replace('#z', this.settings.sgdFourthDiscount ? `${this.settings.sgdFourthDiscount}%` : `$${this.settings.sgdFourthDiscount}`);
              } else if (this.settings.sgdThirdThreshold && diff3 <= 0) {
                if (this.settings.sgdFourthThreshold) {
                  this.sgdDynamicText.innerHTML = this.settings.sgdDynamicTextTemplate.replace('#x', toMoney(diff4)).replace('#y', toMoney(this.settings.sgdFourthThreshold)).replace('#z', this.settings.sgdDiscountType ? `${this.settings.sgdFourthDiscount}%` : `$${this.settings.sgdFourthDiscount}`);
                  if (this.settings.sgdDynamicLargeTextEnabled) this.sgdDynamicLargeText.innerHTML = this.settings.sgdDynamicLargeTextTemplate.replace('#x', toMoney(diff4)).replace('#y', toMoney(this.settings.sgdFourthThreshold)).replace('#z', this.settings.sgdFourthDiscount ? `${this.settings.sgdFourthDiscount}%` : `$${this.settings.sgdFourthDiscount}`);
                } else {
                  this.sgdDynamicText.innerHTML = this.settings.sgdDynamicTextTemplateLastThreshold.replace('#x', toMoney(diff3)).replace('#y', toMoney(this.settings.sgdThirdThreshold)).replace('#z', this.settings.sgdThirdDiscount ? `${this.settings.sgdThirdDiscount}%` : `$${this.settings.sgdThirdDiscount}`);
                  if (this.settings.sgdDynamicLargeTextEnabled) this.sgdDynamicLargeText.innerHTML = this.settings.sgdDynamicLargeTextTemplateLastThreshold.replace('#x', toMoney(diff3)).replace('#y', toMoney(this.settings.sgdThirdThreshold)).replace('#z', this.settings.sgdThirdDiscount ? `${this.settings.sgdThirdDiscount}%` : `$${this.settings.sgdThirdDiscount}`);
                }
              } else if (this.settings.sgdSecondThreshold && diff2 <= 0) {
                if (this.settings.sgdThirdThreshold) {
                  this.sgdDynamicText.innerHTML = this.settings.sgdDynamicTextTemplate.replace('#x', toMoney(diff3)).replace('#y', toMoney(this.settings.sgdThirdThreshold)).replace('#z', this.settings.sgdDiscountType ? `${this.settings.sgdThirdDiscount}%` : `$${this.settings.sgdThirdDiscount}`);
                  if (this.settings.sgdDynamicLargeTextEnabled) this.sgdDynamicLargeText.innerHTML = this.settings.sgdDynamicLargeTextTemplate.replace('#x', toMoney(diff3)).replace('#y', toMoney(this.settings.sgdThirdThreshold)).replace('#z', this.settings.sgdThirdDiscount ? `${this.settings.sgdThirdDiscount}%` : `$${this.settings.sgdThirdDiscount}`);
                } else {
                  this.sgdDynamicText.innerHTML = this.settings.sgdDynamicTextTemplateLastThreshold.replace('#x', toMoney(diff2)).replace('#y', toMoney(this.settings.sgdSecondThreshold)).replace('#z', this.settings.sgdDiscountType ? `${this.settings.sgdSecondDiscount}%` : `$${this.settings.sgdSecondDiscount}`);
                  if (this.settings.sgdDynamicLargeTextEnabled) this.sgdDynamicLargeText.innerHTML = this.settings.sgdDynamicLargeTextTemplateLastThreshold.replace('#x', toMoney(diff2)).replace('#y', toMoney(this.settings.sgdSecondThreshold)).replace('#z', this.settings.sgdSecondDiscount ? `${this.settings.sgdSecondDiscount}%` : `$${this.settings.sgdSecondDiscount}`);
                }
              } else if (this.settings.sgdFirstThreshold && diff1 <= 0) {
                if (this.settings.sgdSecondThreshold) {
                  this.sgdDynamicText.innerHTML = this.settings.sgdDynamicTextTemplate.replace('#x', toMoney(diff2)).replace('#y', toMoney(this.settings.sgdSecondThreshold)).replace('#z', this.settings.sgdDiscountType? `${this.settings.sgdSecondDiscount}%` : `$${this.settings.sgdSecondDiscount}`);
                  if (this.settings.sgdDynamicLargeTextEnabled) this.sgdDynamicLargeText.innerHTML = this.settings.sgdDynamicLargeTextTemplate.replace('#x', toMoney(diff2)).replace('#y', toMoney(this.settings.sgdSecondThreshold)).replace('#z', this.settings.sgdSecondDiscount ? `${this.settings.sgdSecondDiscount}%` : `$${this.settings.sgdSecondDiscount}`);
                } else {
                  this.sgdDynamicText.innerHTML = this.settings.sgdDynamicTextTemplateLastThreshold.replace('#x', toMoney(diff1)).replace('#y', toMoney(this.settings.sgdFirstThreshold)).replace('#z', this.settings.sgdDiscountType ? `${this.settings.sgdFirstDiscount}%` : `$${this.settings.sgdFirstDiscount}`);
                  if (this.settings.sgdDynamicLargeTextEnabled) this.sgdDynamicLargeText.innerHTML = this.settings.sgdDynamicLargeTextTemplateLastThreshold.replace('#x', toMoney(diff1)).replace('#y', toMoney(this.settings.sgdFirstThreshold)).replace('#z', this.settings.sgdFirstDiscount ? `${this.settings.sgdFirstDiscount}%` : `$${this.settings.sgdFirstDiscount}`);
                }
              } else {
                this.sgdDynamicText.innerHTML = this.settings.sgdDynamicTextTemplate.replace('#x', toMoney(diff1)).replace('#y', toMoney(this.settings.sgdFirstThreshold)).replace('#z', this.settings.sgdDiscountType ? `${this.settings.sgdFirstDiscount}%` : `$${this.settings.sgdFirstDiscount}`);
                if (this.settings.sgdDynamicLargeTextEnabled) this.sgdDynamicLargeText.innerHTML = this.settings.sgdDynamicLargeTextTemplate.replace('#x', toMoney(diff1)).replace('#y', toMoney(this.settings.sgdFirstThreshold)).replace('#z', this.settings.sgdFirstDiscount ? `${this.settings.sgdFirstDiscount}%` : `$${this.settings.sgdFirstDiscount}`);
              }
            }
          }

          if (this.settings.sgdUiType !== 'default') {
            if ((this.settings.sgdSecondThreshold && (this.settings.sgdSecondDiscount || this.settings.sgdSecondDiscount)) || (this.settings.fsEnabled && this.settings.sgdShowFsOnTiers && this.settings.fsThreshold)) {
              if (this.settings.sgdUiType === 'advanced') {
                if (this.sgdFreeShippingProgress) this.sgdFreeShippingProgress.value = cart.total;
                if (this.settings.sgdEnabled) {
                  this.sgdFirstProgress.value = this.sgdFreeShippingProgress ? cartTotalPrice - this.settings.fsThreshold : cartTotalPrice;
                  if (this.sgdSecondProgress) this.sgdSecondProgress.value = cartTotalPrice - this.settings.sgdFirstThreshold;
                  if (this.sgdThirdProgress) this.sgdThirdProgress.value = cartTotalPrice - this.settings.sgdSecondThreshold;
                  if (this.sgdFourthProgress) this.sgdFourthProgress.value = cartTotalPrice - this.settings.sgdThirdThreshold;
                }
              } 
              else if (this.settings.sgdFourthThreshold && diff4 <= 0) {
                if (this.sgdFreeShippingProgress) this.sgdFreeShippingProgress.value = 100;
                if (this.settings.sgdEnabled) {
                this.sgdFirstProgress.value = 100;
                  this.sgdSecondProgress.value = 100;
                  this.sgdThirdProgress.value = 100;
                  this.sgdFourthProgress.value = 100;
                }
              } 
              else if (this.settings.sgdThirdThreshold && diff3 <= 0) {
                if (this.settings.sgdFourthThreshold) {
                  if (this.sgdFreeShippingProgress) this.sgdFreeShippingProgress.value = 100;
                  if (this.settings.sgdEnabled) {
                    this.sgdFirstProgress.value = 100;
                    this.sgdSecondProgress.value = 100;
                    this.sgdThirdProgress.value = 100;
                    this.sgdFourthProgress.value = 0;
                  }
                } else {
                  if (this.sgdFreeShippingProgress) this.sgdFreeShippingProgress.value = 100;
                  if (this.settings.sgdEnabled) {
                    this.sgdFirstProgress.value = 100;
                    this.sgdSecondProgress.value = 100;
                    this.sgdThirdProgress.value = 100;
                    if (this.sgdFourthProgress) this.sgdFourthProgress.value = 0;
                  }
                }
              } 
              else if (diff2 <= 0) {
                if (this.settings.sgdThirdThreshold) {
                  if (this.sgdFreeShippingProgress) this.sgdFreeShippingProgress.value = 100;
                  if (this.settings.sgdEnabled) {
                    this.sgdFirstProgress.value = 100;
                    this.sgdSecondProgress.value = 100;
                    this.sgdThirdProgress.value = 0;
                    if (this.sgdFourthProgress) this.sgdFourthProgress.value = 0;
                  }
                } else {
                  if (this.sgdFreeShippingProgress) this.sgdFreeShippingProgress.value = 100;
                  if (this.settings.sgdEnabled) {
                    this.sgdFirstProgress.value = 100;
                    this.sgdSecondProgress.value = 100;
                    if (this.sgdThirdProgress) this.sgdThirdProgress.value = 0;
                    if (this.sgdFourthProgress) this.sgdFourthProgress.value = 0;
                  }
                }
              } 
              else if (diff1 <= 0) {
                if (this.sgdFreeShippingProgress) this.sgdFreeShippingProgress.value = 100;
                if (this.settings.sgdEnabled) {
                  this.sgdFirstProgress.value = 100;
                  this.sgdSecondProgress.value = 0;
                  if (this.sgdThirdProgress) this.sgdThirdProgress.value = 0;
                  if (this.sgdFourthProgress) this.sgdFourthProgress.value = 0;
                }
              } 
              else if (this.settings.fsEnabled && this.settings.fsThreshold && this.settings.sgdShowFsOnTiers && this.sgdFreeShippingProgress && diffFs <= 0) {
                this.sgdFreeShippingProgress.value = 100;
                if (this.settings.sgdEnabled) {
                this.sgdFirstProgress.value = 0;
                  if (this.sgdSecondProgress) this.sgdSecondProgress.value = 0;
                  if (this.sgdThirdProgress) this.sgdThirdProgress.value = 0;
                  if (this.sgdFourthProgress) this.sgdFourthProgress.value = 0;
                }
              } 
              else {
                if (this.sgdFreeShippingProgress) this.sgdFreeShippingProgress.value = 0;
                if (this.settings.sgdEnabled) {
                  this.sgdFirstProgress.value = 0;
                  this.sgdSecondProgress.value = 0;
                  if (this.sgdThirdProgress) this.sgdThirdProgress.value = 0;
                  if (this.sgdFourthProgress) this.sgdFourthProgress.value = 0;
                }
              }

              if (this.settings.sgdEnabled) {
                if (this.settings.sgdFourthThreshold && diff4 <= 0) {
                  this.sgdFreeShippingLabel?.classList.add('bold');
                  this.sgdFirstLabel?.classList.remove('bold');
                  this.sgdSecondLabel?.classList.remove('bold');
                  this.sgdThirdLabel?.classList.remove('bold');
                  this.sgdFourthLabel?.classList.add('bold');
                } 
                else if (this.settings.sgdThirdThreshold && diff3 <= 0) {
                  this.sgdFreeShippingLabel?.classList.add('bold');
                  this.sgdFirstLabel?.classList.remove('bold');
                  this.sgdSecondLabel?.classList.remove('bold');
                  this.sgdThirdLabel?.classList.add('bold');
                  this.sgdFourthLabel?.classList.remove('bold');
                } 
                else if (this.settings.sgdSecondThreshold && diff2 <= 0) {
                  this.sgdFreeShippingLabel?.classList.add('bold');
                  this.sgdFirstLabel?.classList.remove('bold');
                  this.sgdSecondLabel?.classList.add('bold');
                  this.sgdThirdLabel?.classList.remove('bold');
                  this.sgdFourthLabel?.classList.remove('bold');
                } 
                else if (this.settings.sgdFirstThreshold && diff1 <= 0) {
                  this.sgdFreeShippingLabel?.classList.add('bold');
                  this.sgdFirstLabel?.classList.add('bold');
                  this.sgdSecondLabel?.classList.remove('bold');
                  this.sgdThirdLabel?.classList.remove('bold');
                  this.sgdFourthLabel?.classList.remove('bold');
                } 
                else if (this.settings.fsEnabled && this.settings.fsThreshold && this.settings.sgdShowFsOnTiers && this.sgdFreeShippingLabel && diffFs <= 0) {
                  this.sgdFreeShippingLabel.classList.add('bold');
                  this.sgdFirstLabel?.classList.remove('bold');
                  this.sgdSecondLabel?.classList.remove('bold');
                  this.sgdThirdLabel?.classList.remove('bold');
                  this.sgdFourthLabel?.classList.remove('bold');
                } 
                else {
                  this.sgdFreeShippingLabel?.classList.remove('bold');
                  this.sgdFirstLabel?.classList.remove('bold');
                  this.sgdSecondLabel?.classList.remove('bold');
                  this.sgdThirdLabel?.classList.remove('bold');
                  this.sgdFourthLabel?.classList.remove('bold');
                }
              }
            } else {
              if (this.settings.sgdEnabled) {
                if (this.sgdFirstProgress) this.sgdFirstProgress.value = cartTotalPrice;
                if (diff1 <= 0) {
                  this.sgdFirstLabel?.classList.add('bold');
                } else {
                  this.sgdFirstLabel?.classList.remove('bold');
                }
              }
            }
          }
        }

        if (this.settings.gwpEnabled && this.settings.gwpFirstThreshold > 0) {
          const gwpExcludeProductTypeListArray = this.settings.gwpExcludeProductTypeList?.length ? this.settings.gwpExcludeProductTypeList.split(',').filter(item => !!item).map(item => item.toLocaleLowerCase()) : null;
          const hasGWP = cart.items.find(item => item.properties._isGWP);

          let cartTotalPrice = cart.items.reduce((cartTotal, item) => {
            const productType = item.product_type.toLowerCase();
            if (this.settings.gwpExcludeTag && item.properties._tags?.includes(this.settings.gwpExcludeTag)) {
              return cartTotal;
            } else if (gwpExcludeProductTypeListArray?.includes(productType)) {
              return cartTotal;
            } else if (item.properties._isGWP && !this.settings.gwpThresholdUseTotal) {
              return cartTotal;
            } else if (!this.settings.gwpIncludeTag || (this.settings.gwpIncludeTag && item.properties._tags?.includes(this.settings.gwpIncludeTag))) {
              return cartTotal + item.price * item.quantity;
            } else {
              return cartTotal;
            }
          }, 0);

          if (this.settings.gwpThresholdUseTotal) {
            cartTotalPrice -= cart.total_discount;
          }

          const diffFs = this.settings.fsThreshold - cart.total;
          const diff1 = this.settings.gwpFirstThreshold - cartTotalPrice;
          const diff2 = this.settings.gwpSecondThreshold - cartTotalPrice;
          const diff3 = this.settings.gwpThirdThreshold - cartTotalPrice;

          if (this.settings.gwpEnabled && this.gwpBanner) {
            if (diff1 <= 0 && hasGWP) {
              if (this.settings.gwpBannerGiftAdded) {
                this.gwpBanner.innerHTML = this.settings.gwpBannerGiftAdded.replace('#x', this.settings.gwpFirstBoxTitle).replace('#y', toMoney(this.settings.gwpFirstThreshold));
              } else {
                this.gwpBanner.innerHTML = 'You get a <b>free gift</b>!';
              }
            } else if (diff1 <= 0 && !hasGWP) {
              if (this.settings.gwpBannerAfterThreshold) {
                this.gwpBanner.innerHTML = this.settings.gwpBannerAfterThreshold.replace('#x', this.settings.gwpFirstBoxTitle).replace('#y', toMoney(this.settings.gwpFirstThreshold));
              } else {
                this.gwpBanner.innerHTML = 'You can add a <b>free gift</b> to your cart';
              }
            } else if (!hasGWP) {
              if (this.settings.gwpBannerBeforeThreshold) {
                this.gwpBanner.innerHTML = this.settings.gwpBannerBeforeThreshold.replace('#x', this.settings.gwpFirstBoxTitle).replace('#y', toMoney(this.settings.gwpFirstThreshold));
              } else {
                this.gwpBanner.innerHTML = `Add <b>${toMoney(diff1)}</b> & get a <b>free gift</b>!`;
              }
            }
          } else if (this.settings.gwpEnabled && this.settings.gwpMultipleGiftEnabled && this.settings.gwpFirstThreshold > 0 && (this.settings.gwpSecondThreshold > 0 || (this.settings.fsEnabled && this.settings.gwpShowFsOnTiers && this.settings.fsThreshold > 0))) {
            if (this.settings.fsEnabled && this.settings.gwpShowFsOnTiers && this.settings.fsThreshold > 0 && diffFs > 0 && diff1 > 0) {
              this.gwpFsCircle?.classList.remove('full');
              this.gwpFsLine?.classList.remove('full');
              this.gwpFirstCircle?.classList.remove('full');
              this.gwpFirstLine?.classList.remove('full');
              this.gwpSecondCircle?.classList.remove('full');
              this.gwpSecondLine?.classList.remove('full');
              this.gwpThirdCircle?.classList.remove('full');
            } else if (this.settings.fsEnabled && this.settings.gwpShowFsOnTiers && this.settings.fsThreshold > 0 && diffFs <= 0 && diff1 > 0) {
              this.gwpFsCircle?.classList.add('full');
              this.gwpFsLine?.classList.add('full');
              this.gwpFirstCircle?.classList.remove('full');
              this.gwpFirstLine?.classList.remove('full');
              this.gwpSecondCircle?.classList.remove('full');
              this.gwpSecondLine?.classList.remove('full');
              this.gwpThirdCircle?.classList.remove('full');
            } else if (diff1 > 0) {
              this.gwpFirstCircle?.classList.remove('full');
              this.gwpFirstLine?.classList.remove('full');
              this.gwpSecondCircle?.classList.remove('full');
              this.gwpSecondLine?.classList.remove('full');
              this.gwpThirdCircle?.classList.remove('full');
            } else if (diff1 <= 0 && diff2 > 0) {
              this.gwpFsCircle?.classList.add('full');
              this.gwpFsLine?.classList.add('full');
              this.gwpFirstCircle?.classList.add('full');
              this.gwpFirstLine?.classList.add('full');
              this.gwpSecondCircle?.classList.remove('full');
              this.gwpSecondLine?.classList.remove('full');
              this.gwpThirdCircle?.classList.remove('full');
            } else if (diff2 <= 0 && diff3 > 0) {
              this.gwpFsCircle?.classList.add('full');
              this.gwpFsLine?.classList.add('full');
              this.gwpFirstCircle?.classList.add('full');
              this.gwpFirstLine?.classList.add('full');
              this.gwpSecondCircle?.classList.add('full');
              this.gwpSecondLine?.classList.add('full');
              this.gwpThirdCircle?.classList.remove('full');
            } else if (diff3 <= 0) {
              this.gwpFsCircle?.classList.add('full');
              this.gwpFsLine?.classList.add('full');
              this.gwpFirstCircle?.classList.add('full');
              this.gwpFirstLine?.classList.add('full');
              this.gwpSecondCircle?.classList.add('full');
              this.gwpSecondLine?.classList.add('full');
              this.gwpThirdCircle?.classList.add('full');
            }
          }
        }

        if (this.settings.bdEnabled && !this.settings.sgdEnabled) {
          let bdItemsCount = 0;
          bdItemsCount = cart.items.reduce((acc, cur) => {
            if (!cur.properties.hasOwnProperty('_bundleId') && cur.properties.hasOwnProperty('_tags')) {
              if (cur.properties._tags?.includes(this.settings.bdTag) && !cur.selling_plan_allocation && !cur.properties._isGWP && !cur.properties._bbId) {
                return acc + cur.quantity;
              } else {
                return acc;
              }
            } else {
              return acc;
            }
          }, 0);
          let bdTextBanner = '';
          let amountToSave = '';

          if (bdItemsCount > 5 && this.settings.bdFifthItem && this.progressFifthItem.value && this.labelFifthItem.classList.contains('bold')) {
            window.dispatchEvent(new CustomEvent('update-bd-text', {
              detail: {
                amountToSave: 'discount_reached',
                bdItemsCount: bdItemsCount
              }
            }));
            return;
          }
          if (bdItemsCount > 4 && !this.settings.bdFifthItem && this.settings.bdFourthItem && this.progressFourthItem.value && this.labelFourthItem.classList.contains('bold')) {
            window.dispatchEvent(new CustomEvent('update-bd-text', {
              detail: {
                amountToSave: 'discount_reached',
                bdItemsCount: bdItemsCount
              }
            }));
            return;
          }
          if (bdItemsCount > 3 && !this.settings.bdFourthItem && this.settings.bdThirdItem && this.progressThirdItem.value && this.labelThirdItem.classList.contains('bold')) {
            window.dispatchEvent(new CustomEvent('update-bd-text', {
              detail: {
                amountToSave: 'discount_reached',
                bdItemsCount: bdItemsCount
              }
            }));
            return;
          }

          if (bdItemsCount >= 5 && this.settings.bdFifthItem && this.settings.bdFourthItem && this.settings.bdThirdItem) {
            if (this.progressFifthItem) this.progressFifthItem.value = 100;
            if (this.labelFifthItem) this.labelFifthItem.classList.add('bold');
            if (this.labelFourthItem) this.labelFourthItem.classList.remove('bold');
            bdTextBanner = this.settings.bdHeaderBannerMaxTemplate.replace('#product_type', this.settings.bdProductType).replace('#tier_number', 5).replace('#tier_ordinal', 'fifth').replace('#discount', this.settings.bdDiscountType === 'percentage' ? `${this.settings.bdFifthItem}%` : toMoney(this.settings.bdFifthItem));
            amountToSave = 'discount_reached';
          } else if (bdItemsCount >= 4 && this.settings.bdFourthItem && this.settings.bdThirdItem) {
            if (this.progressFourthItem) this.progressFourthItem.value = 100;
            if (this.labelThirdItem) this.labelThirdItem.classList.remove('bold');
            if (this.labelFourthItem) this.labelFourthItem.classList.add('bold');
            if (this.settings.bdFifthItem) {
              if (this.progressFifthItem) this.progressFifthItem.value = 0;
              if (this.labelFifthItem) this.labelFifthItem.classList.remove('bold');
              bdTextBanner = this.settings.bdHeaderBannerTemplate.replace('#product_type', this.settings.bdProductType).replace('#tier_number', 5).replace('#tier_ordinal', 'fifth').replace('#discount', this.settings.bdDiscountType === 'percentage' ? `${this.settings.bdFifthItem}%` : toMoney(this.settings.bdFifthItem));
              amountToSave = this.settings.bdFifthItem;
            } else {
              bdTextBanner = this.settings.bdHeaderBannerMaxTemplate.replace('#product_type', this.settings.bdProductType).replace('#tier_number', 4).replace('#tier_ordinal', 'fourth').replace('#discount', this.settings.bdDiscountType === 'percentage' ? `${this.settings.bdFourthItem}%` : toMoney(this.settings.bdFourthItem));
              amountToSave = 'discount_reached';
            }
          } else if (bdItemsCount >= 3 && this.settings.bdThirdItem) {
            if (this.progressThirdItem) this.progressThirdItem.value = 100;
            if (this.labelSecondItem) this.labelSecondItem.classList.remove('bold');
            if (this.labelThirdItem) this.labelThirdItem.classList.add('bold');
            if (this.settings.bdFourthItem) {
              if (this.progressFifthItem) this.progressFifthItem.value = 0;
              if (this.labelFifthItem) this.labelFifthItem.classList.remove('bold');
              if (this.progressFourthItem) this.progressFourthItem.value = 0;
              if (this.labelFourthItem) this.labelFourthItem.classList.remove('bold');
              bdTextBanner = this.settings.bdHeaderBannerTemplate.replace('#product_type', this.settings.bdProductType).replace('#tier_number', 4).replace('#tier_ordinal', 'fourth').replace('#discount', this.settings.bdDiscountType === 'percentage' ? `${this.settings.bdFourthItem}%` : toMoney(this.settings.bdFourthItem));
              amountToSave = this.settings.bdFourthItem;
            } else {
              bdTextBanner = this.settings.bdHeaderBannerMaxTemplate.replace('#product_type', this.settings.bdProductType).replace('#tier_number', 3).replace('#tier_ordinal', 'third').replace('#discount', this.settings.bdDiscountType === 'percentage' ? `${this.settings.bdThirdItem}%` : toMoney(this.settings.bdThirdItem));
              amountToSave = 'discount_reached';
            }
          } else if (bdItemsCount >= 2) {
            if (this.progressSecondItem) this.progressSecondItem.value = 100;
            if (this.labelFirstItem) this.labelFirstItem.classList.remove('bold');
            if (this.labelSecondItem) this.labelSecondItem.classList.add('bold');
            if (this.settings.bdThirdItem) {
              if (this.progressFifthItem) this.progressFifthItem.value = 0;
              if (this.labelFifthItem) this.labelFifthItem.classList.remove('bold');
              if (this.progressFourthItem) this.progressFourthItem.value = 0;
              if (this.labelFourthItem) this.labelFourthItem.classList.remove('bold');
              if (this.progressThirdItem) this.progressThirdItem.value = 0;
              if (this.labelThirdItem) this.labelThirdItem.classList.remove('bold');
              bdTextBanner = this.settings.bdHeaderBannerTemplate.replace('#product_type', this.settings.bdProductType).replace('#tier_number', 3).replace('#tier_ordinal', 'third').replace('#discount', this.settings.bdDiscountType === 'percentage' ? `${this.settings.bdThirdItem}%` : toMoney(this.settings.bdThirdItem));
              amountToSave = this.settings.bdThirdItem;
            } else {
              bdTextBanner = this.settings.bdHeaderBannerMaxTemplate.replace('#product_type', this.settings.bdProductType).replace('#tier_number', 2).replace('#tier_ordinal', 'second').replace('#discount', this.settings.bdDiscountType === 'percentage' ? `${this.settings.bdSecondItem}%` : toMoney(this.settings.bdSecondItem));
              amountToSave = 'discount_reached';
            }
          } else if (bdItemsCount >= 1) {
            if (this.progressFifthItem) this.progressFifthItem.value = 0;
            if (this.labelFifthItem) this.labelFifthItem.classList.remove('bold');
            if (this.progressFourthItem) this.progressFourthItem.value = 0;
            if (this.labelFourthItem) this.labelFourthItem.classList.remove('bold');
            if (this.progressThirdItem) this.progressThirdItem.value = 0;
            if (this.labelThirdItem) this.labelThirdItem.classList.remove('bold');
            if (this.progressSecondItem) this.progressSecondItem.value = 0;
            if (this.labelSecondItem) this.labelSecondItem.classList.remove('bold');
            if (this.progressFirstItem) this.progressFirstItem.value = 100;
            if (this.labelFirstItem) this.labelFirstItem.classList.add('bold');
            bdTextBanner = this.settings.bdHeaderBannerTemplate.replace('#product_type', this.settings.bdProductType).replace('#tier_number', 2).replace('#tier_ordinal', 'second').replace('#discount', this.settings.bdDiscountType === 'percentage' ? `${this.settings.bdSecondItem}%` : toMoney(this.settings.bdSecondItem));
            amountToSave = this.settings.bdSecondItem;
          } else {
            if (this.progressFirstItem?.value) {
              this.progressFirstItem.value = 0;
              this.labelFirstItem.classList.remove('bold');
            }
            if (this.progressSecondItem?.value) {
              this.progressSecondItem.value = 0;
              this.labelSecondItem.classList.remove('bold');
            }
            if (this.progressThirdItem?.value) {
              this.progressThirdItem.value = 0;
              this.labelThirdItem.classList.remove('bold');
            }
            if (this.progressFourthItem?.value) {
              this.progressFourthItem.value = 0;
              this.labelFourthItem.classList.remove('bold');
            }
            if (this.progressFifthItem?.value) {
              this.progressFifthItem.value = 0;
              this.labelFifthItem.classList.remove('bold');
            }
            if (this.settings.bdFirstItem) {
              bdTextBanner = this.settings.bdHeaderBannerTemplate.replace('#product_type', this.settings.bdProductType).replace('#tier_number', 1).replace('#tier_ordinal', 'first').replace('#discount', this.settings.bdDiscountType === 'percentage' ? `${this.settings.bdFirstItem}%` : toMoney(this.settings.bdFirstItem));
              amountToSave = this.settings.bdFirstItem;
            } else {
              bdTextBanner = this.settings.bdHeaderBannerEmptyTemplate.replace('#product_type', this.settings.bdProductType).replace('#tier_number', 1).replace('#tier_ordinal', 'first').replace('#discount', this.settings.bdDiscountType === 'percentage' ? `${this.settings.bdFirstItem}%` : toMoney(this.settings.bdFirstItem));
              amountToSave = this.settings.bdSecondItem;  
            }
          }
          this.bdBanner.textContent = bdTextBanner;
          window.dispatchEvent(new CustomEvent('update-bd-text', {
            detail: {
              amountToSave: amountToSave,
              bdItemsCount: bdItemsCount
            }
          }));
        }
      });
    }
  });
}
